import { render, staticRenderFns } from "./HomeDescripcion.vue?vue&type=template&id=122b6049&"
import script from "./HomeDescripcion.vue?vue&type=script&lang=js&"
export * from "./HomeDescripcion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports